{
 "_doc": "Starter garb (docs/144): every class's own plain clothes, real items (fk-grammar garb.rs, ids 900-979) a new hero is given with its kit. Names here must match garb.rs; the flavour is the inventory's line of lore.",
 "pieces": [
  {
   "id": 900,
   "cls": "fighter",
   "slot": "torso",
   "name": "Shieldhand's Quilted Gambeson",
   "flavour": "Red wool, stitched in rows, padded thick enough to take a practice blow."
  },
  {
   "id": 901,
   "cls": "fighter",
   "slot": "legs",
   "name": "Shieldhand's Wool Breeches",
   "flavour": "Grey wool, patched at the knee where a shield rests."
  },
  {
   "id": 902,
   "cls": "fighter",
   "slot": "feet",
   "name": "Shieldhand's Marching Boots",
   "flavour": "Black boots, iron-buckled, broken in on the drill yard."
  },
  {
   "id": 903,
   "cls": "fighter",
   "slot": "helmet",
   "name": "Shieldhand's Red Headband",
   "flavour": "Tied on the morning of the first muster, never untied.",
   "helm": "band"
  },
  {
   "id": 910,
   "cls": "rogue",
   "slot": "torso",
   "name": "Cutpurse's Shadow Jerkin",
   "flavour": "Fitted close, so nothing snags on a windowsill."
  },
  {
   "id": 911,
   "cls": "rogue",
   "slot": "legs",
   "name": "Cutpurse's Charcoal Leggings",
   "flavour": "Black as a chimney, quiet as a cat."
  },
  {
   "id": 912,
   "cls": "rogue",
   "slot": "feet",
   "name": "Cutpurse's Soft-Soled Boots",
   "flavour": "Felt soles: the floorboards never hear a thing."
  },
  {
   "id": 913,
   "cls": "rogue",
   "slot": "helmet",
   "name": "Cutpurse's Deep Hood",
   "flavour": "Pulled low, it hides a face from every lantern.",
   "helm": "open"
  },
  {
   "id": 915,
   "cls": "rogue",
   "slot": "waist",
   "name": "Cutpurse's Crimson Sash",
   "flavour": "Somewhere to tuck a lockpick, and a flash of colour for luck."
  },
  {
   "id": 920,
   "cls": "wizard",
   "slot": "torso",
   "name": "Apprentice's Starry Robe",
   "flavour": "Sewn with gold stars by a master who wanted to be noticed."
  },
  {
   "id": 921,
   "cls": "wizard",
   "slot": "legs",
   "name": "Apprentice's Robe Skirts",
   "flavour": "Long enough to trip on, which every apprentice does once."
  },
  {
   "id": 922,
   "cls": "wizard",
   "slot": "feet",
   "name": "Apprentice's Curled Slippers",
   "flavour": "Comfortable for libraries, hopeless in mud."
  },
  {
   "id": 923,
   "cls": "wizard",
   "slot": "helmet",
   "name": "Apprentice's Pointed Hat",
   "flavour": "Tall, pointed and blue: the hat says wizard before you do.",
   "helm": "open"
  },
  {
   "id": 925,
   "cls": "wizard",
   "slot": "waist",
   "name": "Apprentice's Gold Cord",
   "flavour": "A tasselled cord for keeping a spellbook close."
  },
  {
   "id": 930,
   "cls": "cleric",
   "slot": "torso",
   "name": "Acolyte's Sun Tabard",
   "flavour": "White linen with the dawn stitched on it in gold thread."
  },
  {
   "id": 931,
   "cls": "cleric",
   "slot": "legs",
   "name": "Acolyte's Grey Trousers",
   "flavour": "Plain, clean, and kneeled in every morning."
  },
  {
   "id": 932,
   "cls": "cleric",
   "slot": "feet",
   "name": "Acolyte's Pilgrim Wraps",
   "flavour": "Bound for the long road to every shrine."
  },
  {
   "id": 933,
   "cls": "cleric",
   "slot": "helmet",
   "name": "Acolyte's Linen Coif",
   "flavour": "A white coif, starched stiff by the temple laundry.",
   "helm": "open"
  },
  {
   "id": 934,
   "cls": "cleric",
   "slot": "cape",
   "name": "Acolyte's Gold-Hemmed Mantle",
   "flavour": "Light enough to wear in a hot nave, bright enough to find in a crowd."
  },
  {
   "id": 940,
   "cls": "ranger",
   "slot": "torso",
   "name": "Woodward's Green Tunic",
   "flavour": "Dyed the colour of a beech wood in May."
  },
  {
   "id": 941,
   "cls": "ranger",
   "slot": "legs",
   "name": "Woodward's Moss Trousers",
   "flavour": "Olive green, so a ranger lying in bracken disappears."
  },
  {
   "id": 942,
   "cls": "ranger",
   "slot": "feet",
   "name": "Woodward's Tall Boots",
   "flavour": "Up to the knee, against brambles and adders."
  },
  {
   "id": 943,
   "cls": "ranger",
   "slot": "helmet",
   "name": "Woodward's Green Hood",
   "flavour": "The point of the hood catches on every low branch.",
   "helm": "open"
  },
  {
   "id": 944,
   "cls": "ranger",
   "slot": "cape",
   "name": "Woodward's Leaf Cloak",
   "flavour": "Ragged at the hem from a hundred hedges."
  },
  {
   "id": 950,
   "cls": "paladin",
   "slot": "torso",
   "name": "Oathsworn Surcoat",
   "flavour": "The oath is sewn on the chest, so every foe can read it."
  },
  {
   "id": 951,
   "cls": "paladin",
   "slot": "legs",
   "name": "Oathsworn Grey Hose",
   "flavour": "Steel-grey, for one who means to wear steel."
  },
  {
   "id": 952,
   "cls": "paladin",
   "slot": "feet",
   "name": "Oathsworn Steel-Toed Boots",
   "flavour": "Steel at the toe; the rest is a promise."
  },
  {
   "id": 954,
   "cls": "paladin",
   "slot": "cape",
   "name": "Oathsworn Blue Cape",
   "flavour": "Royal blue, given on the day of the vow."
  },
  {
   "id": 955,
   "cls": "paladin",
   "slot": "waist",
   "name": "Oathsworn White Belt",
   "flavour": "White leather, kept white, which is a vow of its own."
  },
  {
   "id": 960,
   "cls": "druid",
   "slot": "torso",
   "name": "Grovekeeper's Leaf Robe",
   "flavour": "Rough-spun, stitched with leaves by a hand that knows them."
  },
  {
   "id": 961,
   "cls": "druid",
   "slot": "legs",
   "name": "Grovekeeper's Wrapped Leggings",
   "flavour": "Bound with cord, the way the old wardens wore them."
  },
  {
   "id": 962,
   "cls": "druid",
   "slot": "feet",
   "name": "Grovekeeper's Fur Footwraps",
   "flavour": "Grey fur against cold earth, and no sound on moss."
  },
  {
   "id": 963,
   "cls": "druid",
   "slot": "helmet",
   "name": "Grovekeeper's Leaf Wreath",
   "flavour": "Woven fresh each spring, and it never quite wilts.",
   "helm": "band"
  },
  {
   "id": 964,
   "cls": "druid",
   "slot": "cape",
   "name": "Grovekeeper's Autumn Mantle",
   "flavour": "The colour of a beech wood in October."
  },
  {
   "id": 970,
   "cls": "bard",
   "slot": "torso",
   "name": "Minstrel's Slashed Doublet",
   "flavour": "Purple and yellow: no one ever forgot a bard dressed like this."
  },
  {
   "id": 971,
   "cls": "bard",
   "slot": "legs",
   "name": "Minstrel's Yellow Hose",
   "flavour": "Bright enough to be seen from the back of the hall."
  },
  {
   "id": 972,
   "cls": "bard",
   "slot": "feet",
   "name": "Minstrel's Pointed Shoes",
   "flavour": "Made for dancing on tables."
  },
  {
   "id": 973,
   "cls": "bard",
   "slot": "helmet",
   "name": "Minstrel's Feathered Cap",
   "flavour": "The feather is from a peacock, or so the bard says.",
   "helm": "open"
  },
  {
   "id": 974,
   "cls": "bard",
   "slot": "cape",
   "name": "Minstrel's Red Cape",
   "flavour": "Swirled at the end of every song."
  },
  {
   "id": 906,
   "cls": "fighter",
   "slot": "torso",
   "name": "Shieldhand's Drill Vest",
   "flavour": "Worn for the drill yard, where nobody hits that hard."
  },
  {
   "id": 907,
   "cls": "fighter",
   "slot": "helmet",
   "name": "Shieldhand's Padded Coif",
   "flavour": "Quilted grey wool, for under a helm the hero does not own yet.",
   "helm": "open"
  },
  {
   "id": 916,
   "cls": "rogue",
   "slot": "torso",
   "name": "Cutpurse's Patched Vest",
   "flavour": "More patches than vest, and a pocket behind every one."
  },
  {
   "id": 917,
   "cls": "rogue",
   "slot": "helmet",
   "name": "Cutpurse's Knotted Bandana",
   "flavour": "Tied tight, so not one hair is left behind at the scene.",
   "helm": "band"
  },
  {
   "id": 926,
   "cls": "wizard",
   "slot": "torso",
   "name": "Apprentice's Moon Robe",
   "flavour": "Silver moons on purple, from a tower that preferred the night."
  },
  {
   "id": 927,
   "cls": "wizard",
   "slot": "helmet",
   "name": "Apprentice's Floppy Hat",
   "flavour": "It was pointed once, before the apprentice sat on it.",
   "helm": "open"
  },
  {
   "id": 936,
   "cls": "cleric",
   "slot": "torso",
   "name": "Acolyte's Pilgrim Cassock",
   "flavour": "Grey for the road, with the temple's sun hung at the heart."
  },
  {
   "id": 937,
   "cls": "cleric",
   "slot": "helmet",
   "name": "Acolyte's Sun Circlet",
   "flavour": "A thin band of brass with the dawn on the brow.",
   "helm": "band"
  },
  {
   "id": 946,
   "cls": "ranger",
   "slot": "torso",
   "name": "Woodward's Hunting Jerkin",
   "flavour": "Russet, the colour of bracken in the fall, with a green collar."
  },
  {
   "id": 947,
   "cls": "ranger",
   "slot": "helmet",
   "name": "Woodward's Feathered Hat",
   "flavour": "The feather marks the first bird that did not get away.",
   "helm": "open"
  },
  {
   "id": 953,
   "cls": "paladin",
   "slot": "helmet",
   "name": "Oathsworn Silver Circlet",
   "flavour": "Plain silver, for one who has sworn but not yet earned a crown of deeds.",
   "helm": "band"
  },
  {
   "id": 956,
   "cls": "paladin",
   "slot": "torso",
   "name": "Oathsworn Blue Tabard",
   "flavour": "Blue, with a white star: the colours of the order before the steel."
  },
  {
   "id": 957,
   "cls": "paladin",
   "slot": "helmet",
   "name": "Oathsworn Blue Coif",
   "flavour": "Blue linen, kept for the long vigil before the oath.",
   "helm": "open"
  },
  {
   "id": 966,
   "cls": "druid",
   "slot": "torso",
   "name": "Grovekeeper's Bark Vest",
   "flavour": "Bark-brown and moss-green; birds have tried to nest in it."
  },
  {
   "id": 967,
   "cls": "druid",
   "slot": "helmet",
   "name": "Grovekeeper's Antler Circlet",
   "flavour": "Two small antlers, shed in the spring and found by the right hand.",
   "helm": "band"
  },
  {
   "id": 976,
   "cls": "bard",
   "slot": "torso",
   "name": "Minstrel's Motley Tunic",
   "flavour": "Red and green in quarters, so the crowd knows a song is coming."
  },
  {
   "id": 977,
   "cls": "bard",
   "slot": "helmet",
   "name": "Minstrel's Plumed Hat",
   "flavour": "Wide enough to pass round for coins after the last song.",
   "helm": "open"
  }
 ]
}